import { fetchMethods } from "../../services/api";

export default {
  namespaced: true,
  state: {
    all: [],
    plugs: [],
  },
  getters: {
    all: (state) => state.all,
    plugs: (state) => state.plugs,
    getById: (state) => (id) => state.all.find((method) => {
      return method.id === id;
    }),
    getPlugById: (state) => (id) => state.plugs.find((plug) => {
      return plug.id === id;
    }),
    current:(state, getters, globalState) => {
      return getters.getById(globalState.build.method);
    },
    currentPlug:(state, getters, globalState) => {
      if (getters.current && getters.current.with_plugs) {
        return getters.getPlugById(globalState.build.plug);
      } else {
        return undefined;
      }
    },
  },
  actions: {
    fetch: ({ commit, rootState }) => {
      return fetchMethods(rootState.environmentId).then(({ data }) => {
        commit('SET_METHODS', data.methods);
        commit('SET_PLUGS', data.plugs);
      });
    },
  },
  mutations: {
    SET_METHODS: (state, data) => {
      state.all = data;
    },
    SET_PLUGS: (state, data) => {
      state.plugs = data;
    },
  },
};
